import { customerBaseApi } from "@/react/services/api/api";
import { EMAIL_CHANNELS } from "../constants";
import { emailChannelsPath } from "../urls";
import { KEY } from "@/react/components/table/useTableMutations";
import schema from "./schema";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { createNotifier } from "@/react/notifications";

export const emailChannelsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getEmailChannels: build.query({
      query: (tenantName) => ({
        url: emailChannelsPath(tenantName),
        method: "GET",
      }),
      providesTags: [EMAIL_CHANNELS],
    }),
    createEmailChannels: build.mutation({
      query: ({ tenantName, emailChannels }) => ({
        url: emailChannelsPath(tenantName),
        method: "POST",
        // POST request breaks when sending is_enabled, but it is required on PUT requests
        body: emailChannels.map((emailChannel) => {
          const { is_enabled, ...emailChannelBodyForPostRequest } =
            emailChannel;
          return emailChannelBodyForPostRequest;
        }),
      }),
      invalidatesTags: [EMAIL_CHANNELS],
    }),
    updateEmailChannels: build.mutation({
      query: ({ tenantName, emailChannels }) => ({
        url: emailChannelsPath(tenantName),
        method: "PUT",
        // Incoming Mail Password is write-only, so the get sends it empty. Need to check if it's been updated
        body: emailChannels.map((emailChannel) => {
          const { incoming_mail_password, ...emailChannelBodyForPutRequest } =
            emailChannel;
          if (incoming_mail_password) {
            return emailChannelBodyForPutRequest;
          }
          return emailChannel;
        }),
      }),
      invalidatesTags: [EMAIL_CHANNELS],
    }),
    deleteEmailChannels: build.mutation({
      query: ({ tenantName, emailChannelIds }) => ({
        url: `${emailChannelsPath(tenantName)}/delete`,
        method: "POST",
        body: emailChannelIds,
      }),
      invalidatesTags: [EMAIL_CHANNELS],
    }),
  }),
});

export const {
  useGetEmailChannelsQuery,
  useCreateEmailChannelsMutation,
  useUpdateEmailChannelsMutation,
  useDeleteEmailChannelsMutation,
} = emailChannelsApi;

export const handleCreateResponse = ({
  rowsToCreate,
  setRowsToCreate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToCreate,
    setRows: setRowsToCreate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("create", "email channel"),
  });

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("update", "email channel"),
  });

export const handleDeleteResponse = ({
  rowsToDelete,
  setRowsToDelete,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToDelete,
    setRows: setRowsToDelete,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("delete", "email channel"),
    isVoidResponse: true,
  });
